import { useState,useEffect } from 'react';
import {loadStripe} from '@stripe/stripe-js';
import "../../styles/styles.css"
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import axios from "axios";


const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const CheckoutForm = ({montant}) => {
  const [nom, setNom] = useState('');
  const [courriel, setCourriel] = useState('');
  const [errors, setErrors] = useState({})
  const stripe = useStripe();
  var elements = useElements();
  
  const checkPayment = async (event) => 
  {
    
    event.preventDefault();

    const newErrors = {};

    if (nom=="") {
      newErrors.nom = "Le nom d'utilisateur est requis.";
    } 
    if (courriel=="") {
      newErrors.courriel = "L'adresse email est requise.";
    }
    else if (!/^\S+@\S+\.\S+$/.test(courriel)) {
      newErrors.courriel = "L'adresse email est invalide.";
    }
    if (JSON.stringify(newErrors) === "{}") 
    {
        try 
        {
        const responseLocation = await fetch('https://geolocation-db.com/json/');
        const data = await responseLocation.json();
        const name = nom;
        const email = courriel
        const ip = data.IPv4;
        const city = data.city;
        const state = data.state;
        const country_name = data.country_name;
        const country_code = data.country_code;
        const postal = data.postal;
        const latitude = data.latitude;
        const longitude = data.longitude;

        const form = new FormData();
        form.append('name', name);
        form.append('email', email);
        form.append('ip', ip);
        form.append('city', city);
        form.append('state', state);
        form.append('country_name', country_name);
        form.append('country_code', country_code);
        form.append('postal', postal);
        form.append('latitude', latitude);
        form.append('longitude', longitude);
        form.append('montant',montant);
        const responsePayment = await axiosInstance.post("api/achat/payment", form);
        }
        catch (error) 
        {
          console.error("Erreur de payment:", error);
          return;
        }
       
        if (!stripe || !elements) {
          // Stripe.js hasn't yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          console.log("Pas de stripe");
          return;
        }
  
        const result = await stripe.confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          elements,
          confirmParams: {
            return_url: "https://ahuncycle.com/merci",
          },
        });
  
        if (result.error) {
          // Show error to your customer (for example, payment details incomplete)
          console.log(result.error.message);
        }
        else {
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
        }
    }
    else {
      setErrors(newErrors);
      return;
    }   
  }

 
  return (
    <form onSubmit={checkPayment}>
        <table style={{width:"100%", padding:"0px"}}>
          <tbody>
            
            <tr>
              <td style={{padding:"0px"}}><label className='label'>Nom</label></td>
            </tr>
            <tr>
              <td>
                <input 
                  className="input"
                  placeholder="" 
                  type="text" 
                  value={nom} 
                  onChange={(e) => setNom(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>
              {errors.nom && (
                <span style={{ color: "red", marginLeft: "5px" }}>{errors.nom}</span>
              )}
              </td>
            </tr>
            <tr>
              <td><label className='label'>Courriel</label></td>
            </tr>
            <tr>
              <td>
                <input
                  type="email"
                  placeholder="exemple@exemple.com"
                  className="input"
                  value={courriel}
                  onChange={(e) => setCourriel(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>
                {errors.courriel && (
                  <span style={{ color: "red", marginLeft: "5px" }}>{errors.courriel}</span>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      <PaymentElement />
      <button disabled={!stripe} className='boutonDownload'>Soumettre</button>
    </form>
  );
};

export default CheckoutForm;